import React, { useEffect, useState } from "react";

import { UserDataContext } from "contexts/UserDataContext";

export default function UserDataWrapper(props) {
  const [userData, setUserData] = useState(() => {
    const storedData = localStorage.getItem("userData");
    try {
      return storedData ? JSON.parse(storedData) : {};
    } catch (e) {
      console.error("Failed to parse userData from localStorage:", e);
      return {};
    }
  });

  useEffect(() => {
    localStorage.setItem("userData", JSON.stringify(userData));
  }, [userData]);

  function addUserData(data) {
    setUserData(data);
  }

  return (
    <UserDataContext.Provider
      value={{ userData: userData, addUserData: addUserData }}
    >
      {props.children}
    </UserDataContext.Provider>
  );
}
